
export default function DeveloperCTA() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-[#22577A] via-[#38a3a5] to-[#66b3ff] rounded-3xl overflow-hidden">
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Left Side - Info */}
            <div className="p-8 lg:p-12 text-white">
              <div className="inline-flex items-center px-4 py-2 bg-white/20 rounded-full text-white font-medium mb-6">
                <i className="ri-code-box-line mr-2"></i>
                For Developers
              </div>

              <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                Build Your Own Integrations
              </h2>

              <p className="text-xl text-white/90 mb-8 leading-relaxed">
                Use our powerful API and webhooks to create custom integrations, automate workflows, and build tools that fit your unique needs.
              </p>

              <div className="space-y-6 mb-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-code-s-slash-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2">RESTful API</h3>
                    <p className="text-white/80">
                      Full-featured REST API with comprehensive documentation and code examples
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-webhook-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2">Real-time Webhooks</h3>
                    <p className="text-white/80">
                      Get instant notifications for events like post publishing, analytics updates, and more
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-book-open-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2">Complete Documentation</h3>
                    <p className="text-white/80">
                      Step-by-step guides, API references, and interactive examples to get you started
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-2">Enterprise Security</h3>
                    <p className="text-white/80">
                      OAuth 2.0, API key authentication, and rate limiting to keep your data secure
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="#"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#22577A] rounded-lg font-semibold hover:shadow-xl transition-all cursor-pointer"
                >
                  <i className="ri-file-list-3-line"></i>
                  View API Docs
                </a>
                <a
                  href="#"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-all cursor-pointer"
                >
                  <i className="ri-github-fill"></i>
                  See Examples
                </a>
              </div>
            </div>

            {/* Right Side - Code Example */}
            <div className="bg-[#1a1a1a] p-8 lg:p-12 flex items-center">
              <div className="w-full">
                <div className="flex items-center gap-2 mb-6">
                  <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="ml-4 text-gray-400 text-sm font-mono">api-example.js</span>
                </div>

                <pre className="text-sm text-green-400 font-mono overflow-x-auto">
                  <code>{`// Initialize AgenticAI API
const agenticai = require('@agenticai/sdk');

const client = new agenticai.Client({
  apiKey: process.env.AGENTICAI_KEY
});

// Create and schedule a post
await client.posts.create({
  content: "Check out our latest blog!",
  platforms: ['facebook', 'twitter'],
  scheduleAt: '2025-11-10T14:00:00Z',
  aiOptimize: true
});

// Get analytics
const analytics = await client.analytics.get({
  range: 'last_30_days'
});

console.log(analytics);`}</code>
                </pre>
              </div>
            </div>
          </div>
        </div>

        {/* Integration Ecosystem CTA */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-2xl p-6 border-2 border-[#66b3ff]/30">
            <i className="ri-store-3-line text-4xl text-[#22577A] mb-4"></i>
            <h3 className="text-xl font-bold text-[#22577A] mb-3">Integration Marketplace</h3>
            <p className="text-gray-700 mb-4">
              Share your custom integrations with the community (coming soon)
            </p>
            <a href="#" className="text-[#22577A] font-semibold hover:text-[#38a3a5] transition-colors inline-flex items-center gap-2 cursor-pointer">
              Learn More
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-2xl p-6 border-2 border-[#66b3ff]/30">
            <i className="ri-community-line text-4xl text-[#22577A] mb-4"></i>
            <h3 className="text-xl font-bold text-[#22577A] mb-3">Developer Community</h3>
            <p className="text-gray-700 mb-4">
              Join our Discord to connect with other developers building on AgenticAI
            </p>
            <a href="#" className="text-[#22577A] font-semibold hover:text-[#38a3a5] transition-colors inline-flex items-center gap-2 cursor-pointer">
              Join Discord
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-2xl p-6 border-2 border-[#66b3ff]/30">
            <i className="ri-customer-service-line text-4xl text-[#22577A] mb-4"></i>
            <h3 className="text-xl font-bold text-[#22577A] mb-3">Developer Support</h3>
            <p className="text-gray-700 mb-4">
              Get help from our team with priority support for integration questions
            </p>
            <a href="#" className="text-[#22577A] font-semibold hover:text-[#38a3a5] transition-colors inline-flex items-center gap-2 cursor-pointer">
              Contact Support
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
